import React, { Component } from 'react';
import ServiceMessage from 'components/ServiceMessage';
import { isChunkLoadError, recoverChunk } from '../helpers/chunkRecovery';

// A ChunkLoadError means the user's index.html references JS chunks that no
// longer exist on the server — typically right after a deploy invalidated the
// previous bundle. The fix is a hard reload to fetch the new index.html and
// the chunk hashes it points to. We guard with sessionStorage so we don't
// infinite-loop if the new HTML is also broken.

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError = (error) => {
    if (recoverChunk(error)) return { hasError: false, reloading: true };
    return { hasError: true };
  };

  componentDidCatch = (error, errorInfo) => {
    console.error('Error caught by ErrorBoundary: ', error, errorInfo);
    if (isChunkLoadError(error)) {
      // Reload is already in flight from getDerivedStateFromError — don't surface.
      return;
    }
    this.setState({ error, errorInfo });
  };

  render() {
    const { children } = this.props;
    const { hasError, reloading, error } = this.state;

    if (reloading) {
      return null;
    }
    if (hasError) {
      return <ServiceMessage error={error} />;
    }

    return children;
  }
}

export default ErrorBoundary;
